import { Checkbox } from "@mui/material";
import { useContext, useMemo } from "react";

import { getFormattedPrice } from "./helpers";
import { inject } from "../../../../../../../../lib/itn-ui-kit/services/service-container";
import DataContext from "../../../../../../../context/DataContext";

const ApptBillsList = ({ bills, setSelectedBills, isDeleteMode = false }) => {
  const currentUserService = inject("current-user-service");
  const { userType } = useContext(DataContext);
  const canEdit = currentUserService?.userRoles?.permissions.includes(
    "provider.change_administeredservices"
  );
  const canDelete = currentUserService?.userRoles?.permissions.includes(
    "provider.delete_administeredservices"
  );
  const isAuthorizedProvider = useMemo(
    () => userType !== "Provider" && (canEdit || canDelete),
    [userType, canEdit, canDelete]
  );
  const gridCols = isDeleteMode
    ? "grid-cols-5"
    : "grid-cols-[40px_1fr_1fr_1fr_1fr_1fr]";

  function formatDate(bill) {
    if (bill?.updated_at) return new Date(bill.updated_at).toLocaleString();
    if (bill?.created_at) return new Date(bill.created_at).toLocaleString();
    return "N/A";
  }

  function handleCheckedItems(checked, bill) {
    if (checked) {
      setSelectedBills?.((prev) => [...prev, bill]);
    } else {
      setSelectedBills?.((prev) => [
        ...prev.filter((element) => element.pk !== bill.pk),
      ]);
    }
  }

  return (
    <>
      {bills?.length > 0 ? (
        <>
          {/* Header */}
          <div
            className={`grid items-center w-full ${gridCols}  gap-4 font-semibold mb-2`}
          >
            {!isDeleteMode && <div id="checkbox"></div>}
            <div className="flex flex-wrap w-full h-full p-2 overflow-x-hidden place-content-center">
              CPT Code
            </div>
            <div className="flex flex-wrap w-full h-full p-2 overflow-x-hidden place-content-center">
              CPT Description
            </div>
            <div className="flex flex-wrap w-full h-full p-2 overflow-x-hidden place-content-center">
              Amount
            </div>
            <div className="flex flex-wrap w-full h-full p-2 overflow-x-hidden place-content-center">
              Last Update/Created Time
            </div>
            <div className="flex flex-wrap w-full h-full p-2 overflow-x-hidden place-content-center">
              {" "}
              Last Update/Created By
            </div>
          </div>
          <>
            {/* Body */}
            {bills.map((bill, idx) => (
              <div
                key={idx}
                className={`grid items-center w-full ${gridCols} gap-4 mb-4`}
              >
                {!isDeleteMode && (
                  <div className="flex flex-wrap w-full h-full p-2 place-content-center">
                    <Checkbox
                      disabled={!isAuthorizedProvider}
                      onChange={(_, checked) =>
                        handleCheckedItems(checked, bill)
                      }
                      className="p-0 hover:bg-transparent"
                    />
                  </div>
                )}
                <div className="flex flex-wrap w-full h-full p-2 overflow-x-hidden border-r-2 border-gray-200 place-content-center">
                  {bill.service?.service_code || "N/A"}
                </div>
                <div className="flex flex-wrap w-full h-full p-2 overflow-x-hidden border-r-2 border-gray-200 place-content-center">
                  {bill.service?.service_name || "N/A"}
                </div>
                <div className="flex flex-wrap w-full h-full p-2 overflow-x-hidden border-r-2 border-gray-200 place-content-center">
                  {getFormattedPrice(bill.price)}
                </div>
                <div className="flex flex-wrap w-full h-full p-2 overflow-x-hidden border-r-2 border-gray-200 place-content-center">
                  {formatDate(bill)}
                </div>
                <div className="flex flex-wrap w-full h-full p-2 overflow-x-hidden place-content-center">
                  {bill?.updated_by?.name ?? bill?.created_by?.name ?? "N/A"}
                </div>
              </div>
            ))}
          </>
        </>
      ) : (
        <div className="p-4 mt-6 text-center bg-gray-200 rounded-lg">
          <h3>No Administered Services Found</h3>
        </div>
      )}
    </>
  );
};

export default ApptBillsList;
